import Config from "@/config/config"

export const supportedLanguages = ['en', 'de'] as const
export type SupportedLocale = typeof supportedLanguages[number]

export default function getLanguageFromDomain() : string {
  let determinedLanguage = 'en'
  if (window.location.href && /(.*)\.com\/de(\/(.*))?$/.test(window.location.href)) {
    determinedLanguage = 'de'
  }

  if (Config.LANG && typeof(Config.LANG) === 'string' && supportedLanguages.indexOf(Config.LANG) >= 0) {
    determinedLanguage = Config.LANG
  }

  if (window.location.search) {
    const queryParams = new URLSearchParams(window.location.search)
    const langParam = queryParams.get('_lang')
    if (langParam && supportedLanguages.indexOf(langParam) >= 0) {
      determinedLanguage = langParam
    }
  }

  return determinedLanguage
}

export function isSupportedLocale(locale: string): locale is SupportedLocale {
  return supportedLanguages.includes(locale as SupportedLocale)
}
